import React from 'react';

interface AddApplicationCardProps {
  onClick: () => void;
}

export const AddApplicationCard: React.FC<AddApplicationCardProps> = ({ onClick }) => {
  return (
      <div
          className="flex flex-col items-center justify-center bg-white rounded-lg shadow-md p-12 cursor-pointer hover:shadow-lg transition-shadow duration-300"
          onClick={onClick}
          style={{
              width: '280px',
              height: '280px',
              background: 'white',
              borderRadius: '12px',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
          }}
      >
          <div className="flex items-center justify-center w-24 h-24 bg-blue-100 rounded-full mb-6">
              <span className="text-[#0F2A4F] text-4xl font-bold">+</span>
          </div>
          <span className="text-[#0F2A4F] font-medium text-center text-lg">Add new Application</span>
      </div>
  );
};